module.exports = __webpack_public_path__ + "static/media/PM82.1af5f63d.JPG";